import { styled } from 'styled-components';

import { LargeContainer } from 'app/components/container';
import { Image } from 'app/components/image';
import { breakpointLargeTablet } from 'app/style/breakpoints';
import { colorNeutral, colorPrimary500, colorSecondary900 } from 'app/style/colors';
import { focus } from 'app/style/mixins';

export const StyledHeader = styled.header`
    background: ${colorPrimary500};
    position: relative;
`;

export const StyledHeaderContainer = styled(LargeContainer)`
    display: flex;
    align-items: center;
    min-height: 72px;
    justify-content: right;
`;

export const StyledLogo = styled(Image)`
    width: 96px;
    position: absolute;
    inset: 0;
    margin: auto;

    @media (min-width: ${breakpointLargeTablet}) {
        width: 253px;
    }
`;

export const StyledLogoutButton = styled.button`
    color: ${colorNeutral};
    font-size: 16px;
    height: 48px;
    font-weight: bold;
    background: ${colorPrimary500};
    border-radius: 4px;
    border: 0;
    margin-left: auto;

    &:hover {
        background: ${colorNeutral};
        color: ${colorSecondary900};
        cursor: pointer;
    }

    ${focus};

    @media (min-width: ${breakpointLargeTablet}) {
        font-size: 18px;
        width: 118px;
        border: 2px solid rgb(255 255 255 / 50%);
    }
`;
